<template>
  <Modal :name="name" custom>
    <WarRoomSharePopup :sharable-type="sharableType" :sharable-url="sharableUrl" @on-close="closeModal" />
  </Modal>
</template>

<script lang="ts">
import Vue from 'vue';
import Modal from '@/components/common/Modal/Modal.vue';
import WarRoomSharePopup from '@/components/partials/war-room/WarRoomShare/WarRoomSharePopup/WarRoomSharePopup.vue';
import { modalNames } from '~/components/partials/war-room/constants';

export default Vue.extend({
  name: 'WarRoomShareModal',
  components: { Modal, WarRoomSharePopup },
  data() {
    return {
      name: modalNames.SHARE_POST_OR_COMMENT,
    };
  },
  computed: {
    sharableType(): string {
      return this.$route.query.sharable_type as string;
    },
    sharableUrl(): string {
      return this.$route.query.sharable_url as string;
    },
  },
  methods: {
    closeModal(): void {
      this.$modal.hide(modalNames.SHARE_POST_OR_COMMENT);
    },
  },
});
</script>
